import { render, staticRenderFns } from "./code-input.vue?vue&type=template&id=fcaeab0a&scoped=true&"
import script from "./code-input.vue?vue&type=script&lang=js&"
export * from "./code-input.vue?vue&type=script&lang=js&"
import style0 from "./code-input.vue?vue&type=style&index=0&id=fcaeab0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaeab0a",
  null
  
)

export default component.exports